// Spanish articles — served under /es/journal/:slug
// Paired with EN/FR counterparts via enSlug/frSlug for hreflang.

export const ARTICLES_ES = [
  {
    slug: "horizon-construction-caso-de-estudio",
    enSlug: "horizon-construction-case-study",
    frSlug: "horizon-construction-etude-de-cas",
    pillar: "simplification",
    pillarLabel: "Simplificación de procesos",
    title: "Construction Horizon: respuestas a los RFI en horas, no en días",
    excerpt:
      "Seis semanas. Un solo proceso crítico. Respuestas a los RFI 43 % más rápidas — y un equipo cuyas decisiones ya no esperan en los buzones. La historia completa de un resultado medido.",
    readTime: "5 min de lectura",
    seoTitle: "Caso de estudio Construction Horizon — RFI 43 % más rápidos | Ocean Data",
    sections: [
      { paras: [
        "Cada resultado sólido que podemos demostrar empieza igual: no con un gran programa de transformación, sino con un solo proceso que perdía horas en silencio. Para Construction Horizon, ese proceso era los RFI — las solicitudes de información que deciden si una obra avanza o espera.",
      ]},
      { h: "La situación", paras: [
        "Los RFI vivían en los buzones de correo. Una pregunta de la obra llegaba por correo, esperaba a que la persona correcta la notara, se reenviaba, se respondía, se perdía, se volvía a preguntar. Cada una era pequeña. Juntas marcaban el ritmo de las decisiones — y el ritmo se contaba en días, cuando el trabajo necesitaba horas.",
        "Nadie en Horizon era lento. La información sí. Quedaba atrapada en los espacios entre la obra, la oficina y quienes aprueban — y la gente pasaba sus mañanas transportándola a mano.",
      ]},
      { h: "El enfoque", paras: [
        "Hicimos lo que siempre hacemos primero: una conversación, para mapear cómo viajaba realmente un RFI — no cómo el organigrama decía que debía viajar. Luego conectamos las herramientas que ya usaban para que cada RFI tuviera un solo hogar: enviado una vez, visible de inmediato por la persona correcta, respondido en el mismo expediente, accesible a todos los que lo necesitaban.",
        "El equipo practicó primero en una copia segura de sus datos. Nada cambió en sus herramientas diarias. Lo que cambió fue que la pregunta y la respuesta por fin vivían en el mismo lugar.",
      ]},
      { h: "El resultado, medido", paras: [
        "Seis semanas después, el tiempo de respuesta a los RFI había bajado 43 %. No una estimación — una medición, tomada de sus propios registros. Como dijo su Director de Operaciones: «En seis semanas, el tiempo de respuesta de nuestro equipo a los RFI cayó 43 %. Las decisiones ahora toman horas, no días.»",
        "Note lo que el número realmente describe: no un software adoptado, sino tiempo devuelto. Menos mañanas persiguiendo información. Menos decisiones esperando al final de un hilo de correos. La obra y la oficina por fin avanzan a la misma velocidad.",
      ]},
      { h: "La lección que reutilizamos", paras: [
        "Horizon no empezó con diez procesos. Empezó con el que más dolía, lo probó con un número, y dejó que ese número defendiera todo lo demás. Ese es todo el método: un proceso crítico, puesto a fluir, medido — luego se amplía.",
        "Si su versión del RFI es la cotización, la orden de cambio o la factura, la forma de la solución es la misma. El primer paso es simplemente nombrarla.",
      ]},
    ],
    stick: {
      copy: "Seis semanas. Un proceso. Cuarenta y tres por ciento.",
      visual: "Dos cronómetros sobre el mismo escritorio — antes: «días»; después: «horas».",
      film: "Un trabajador con casco envía una pregunta desde la obra; un reloj gira en pantalla dividida; la respuesta llega antes de que su café se enfríe.",
      why: "Una empresa con nombre, un proceso con nombre, un número medido — la precisión es lo que hace creíble y repetible una afirmación.",
    },
  },
];

// Map: English article slug → Spanish article slug (hreflang pairing)
export const ES_BY_EN_SLUG = ARTICLES_ES.reduce((acc, a) => {
  if (a.enSlug) acc[a.enSlug] = a.slug;
  return acc;
}, {});

export const getArticleEs = (slug) => ARTICLES_ES.find((a) => a.slug === slug);
